// extracted by mini-css-extract-plugin
module.exports = {"container":"PlayerNameAndAvatar_container__3LOIw","center":"PlayerNameAndAvatar_center__3cFe6","name":"PlayerNameAndAvatar_name__2ODmQ"};